import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/pet/og.png';
import type { BasePageConfig } from '../../../BasePageConfig';

export const config: BasePageConfig = {
  seo: {
    title: 'Pet Insurance for Dogs - Lemonade Pet Health Insurance',
    metaTitle: 'Pet Insurance for Dogs - Lemonade Pet Health Insurance',
    description: 'Pet Insurance Tailored for Your Dog Protection just right for your pet (and your pocket)',
    ogImage: ogImage.src,
    uniqueCanonicalUrl: 'https://www.lemonade.com/pet',
    noIndex: true,
  },
  layout: { ...sharedConfig['en-US'].layout },
};
